import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 -960 960 960"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M400-360q-8 0-14-6t-6-14v-200q0-8 6-14t14-6h140q17 0 28.5 11.5T580-560v40q0 17-11.5 28.5T540-480q17 0 28.5 11.5T580-440v40q0 17-11.5 28.5T540-360zm40-150h80v-30h-80zm0 90h80v-30h-80zm-290 60q-13 0-21.5-8.5T120-390v-170q0-17 11.5-28.5T160-600h120q17 0 28.5 11.5T320-560v170q0 13-8.5 21.5T290-360t-21.5-8.5T260-390v-30h-80v30q0 13-8.5 21.5T150-360m30-120h80v-60h-80zm500 120q-17 0-28.5-11.5T640-400v-160q0-17 11.5-28.5T680-600h120q17 0 28.5 11.5T840-560v20q0 13-8.5 21.5T810-510t-21.5-8.5T780-540h-80v120h80q0-13 8.5-21.5T810-450t21.5 8.5T840-420v20q0 17-11.5 28.5T800-360z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }